import { typeCheckAppModule } from "../../../../core/utils";
import { NAME } from "./constants";
import { ValidationReportsPage } from "./ValidationReportsPage";

export const validationReportsPage = typeCheckAppModule({
    NAME,
    Container: ValidationReportsPage,
});
